import { Component, Input, Output, EventEmitter, ViewEncapsulation, ViewChild, ElementRef, inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatIconModule } from '@angular/material/icon';
import { ToastrService } from 'ngx-toastr';
import '@ui5/webcomponents/dist/TimePicker.js';
import "@ui5/webcomponents-localization/dist/Assets.js";
import TimePicker from '@ui5/webcomponents/dist/TimePicker.js';

import { AppConstants } from '../../app.constants';
import { ToastrMessageEnum } from '../../core/enums/toastr-messages/toastr-message.enum';

@Component({
  selector: 'duration-picker',
  standalone: true,
  imports: [
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './duration-picker.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrls: ['./duration-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DurationPickerComponent {
  private toastrService = inject(ToastrService);
  _duration: string;
  @ViewChild('durationPicker') durationPicker: ElementRef<TimePicker>;

  @Input() tooltip: string = AppConstants.DEFAULT_DURATION_PICKER_TOOLTIP;
  @Input() disabled: boolean;

  @Input()
  get duration() {
    return this._duration;
  }

  @Output() dateTimeChanged = new EventEmitter<void>();
  @Output() durationChange = new EventEmitter();
  set duration(value) {
    this._duration = value;
    this.durationChange.emit(this._duration);
  }

  onDateTimeChange(): void {
    if (this.durationPicker.nativeElement.value) {
      const [hh, mm, ss] = this.durationPicker.nativeElement.value.split(":").map(v => Number(v));

      if (hh === 0 && mm === 0 && ss === 0) {
        this.durationPicker.nativeElement.value = AppConstants.MIN_PLAYLIST_ITEM_DURATION;
        this.toastrService.info(ToastrMessageEnum.PlaylistItemMinDurationInfoMessage);
      }

      this.duration = this.durationPicker.nativeElement.value;
      this.dateTimeChanged.emit();
    }
  }

  onDatePickerOpen(): void {
    this.durationPicker.nativeElement.openPicker();
  }
}
